export default __webpack_public_path__ + "static/media/icon-mobile-app-cms.f60943bb.svg";